import textFieldValidator from './textFieldValidator';

const validatorEnum = {
    isRequired: textFieldValidator().isRequired,
    isEmail: textFieldValidator().isEmail,
    disableChinese: textFieldValidator().disableChinese,
    checkPassword: textFieldValidator().checkPassword,
    checkConfirmPassword: textFieldValidator().checkConfirmPassword,
    isDomain: textFieldValidator().isDomain,
    disableAlphabet: textFieldValidator().disableAlphabet,
};
export default validatorEnum;
